import { Message } from "view-design";
import { extendObj } from "./tools";

export default (command, errMessage) => {
  let defaultParams = {
    "001": "操作命令错误",
    "002": "获取到的列表数据为0",
    "003": "分页参数错误",
    "004": "必填参数错误",
    "005": "插入数据失败",
    "006": "检测到要插入的数据已经存在",
    "011": "修改数据失败",
    "012": "文件上传失败",
    "014": "没有操作权限",
    "016": "删除数据失败",
    "041": "工单已经被抢",
    "046": "操作失败",
    "047": "此动作已被其他人员处理完成",
    "048": "用户参数错误",
    "049": "限制报单工单数量",
    "050": "输入的内容不被允许",
    "051": "已过期的操作",
    "404": "page missing"
  };
  if (typeof errMessage === "object") {
    defaultParams = extendObj(defaultParams, errMessage);
  }
  // let result = extendObj({a: 1},{b:2});
  // console.log(result);
  Message.error(defaultParams[command]);
};
